export default __webpack_public_path__ + "static/media/santamonica.4b5162bc.jpg";